<script lang="ts">
  import Icon from "./Icon.svelte";
  import { useNavigate } from 'svelte-navigator';
  import { useLocation } from "svelte-navigator";
  import widgetStore from '../store/widget';
  import { WidgetState } from "../types/state";
  import { fly } from 'svelte/transition'
  import { backOut } from 'svelte/easing'
  import ButtonRounded from "../common/ButtonRounded.svelte";
  import { onMount } from 'svelte'
  import { addSurvey } from "../domain/call/note.action";
  import sessionStore from '../store/session';
  import toast from '../services/toast';
  import { AmplitudeLogger, EVENTS } from "../services/utils";
  
  const location = useLocation();

  const navigate = useNavigate();
  let dropdown = null
  let loading = false
  let rating: Record<string, string> = {}
  let errors: Record<string, string> = {}

  const widgetConfig: WidgetState = $widgetStore;

  const rates: string[] = ['😍', '🙂', '😐', '🙁', '😖'];

  let selectedRate: number = null;

  const selectRate = idx => {
    selectedRate = idx
  }

  const processRatings = async () => {
    errors.survey = null

    if (selectedRate === null) {
      errors.survey = "Kindly rate us";
      toast.warn(errors.survey)
      return false;
    }

    loading = true;

    try {
      const payload = {
        feedback: `${rating.message}`,
        rating: 5-selectedRate
      }
      await addSurvey($sessionStore.profile.business.id, payload)
      toast.success("Thanks for taking your time to rate us.")
      AmplitudeLogger.log(EVENTS.SURVEY_SAVED)
      dropdown = null
    } catch (e) {
      errors.survey = e.message || "An error occured, Please try again"
      toast.warn(errors.survey)
    } finally {
      loading = false;
    }
  }


  const navs: Array<{icon: string, uri: string, title: string}> = [
    {icon: "dialer", uri: "/", title: "Make a call"},
    {icon: "call-log", uri: "/call-logs", title: "Call Logs"},
    {icon: "contact", uri: "/contacts", title: "Contacts"},
    {icon: "transfer", uri: "/queue", title: "Call Queue"}
  ]

  onMount(async () => {

    const review_time = localStorage.getItem("review_time")
    const now: Date = new Date();
    if (
      !review_time ||   
      ((now.getTime() - new Date(review_time).getTime()) / 3600000 > 12 && now.getHours() % 12 > 0)
    ) {
      setTimeout(async () => {
        dropdown = true
        localStorage.setItem("review_time", now.toString())
      }, 10000)
    }
  })

</script>
<div class="absolute bottom-0 w-full">
  <div class="flex bg-white mx-4 py-1 px-3">
    <div class="flex mb-3 justify-between items-center w-full text-gray-500 text-xs">
      {#each navs as nav}
         <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="flex flex-col justify-center items-center" on:click={() => navigate(nav.uri)}>
          <Icon icon={nav.icon} color={$location.pathname === nav.uri ? widgetConfig.primary_text_color || "#1671D9" : "#98A2B3"} size="30" />
          <span class="mt-2" style="color: {$location.pathname === nav.uri ? widgetConfig.primary_text_color || "#1671D9" : "#98A2B3"};">{ nav.title }</span>
        </div>
      {/each}
    </div>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="flex absolute left-0 right-0 bottom-0 h-2 primary-bg-color" on:click={() => dropdown = true}>rate</div>
  </div>
</div>

{#if dropdown}
<div class="absolute w-full z-20 top-0 bottom-0 bg-gray-700/50" transition:fly>
  <div class="p-4 rounded-lg m-4 shadow-xl bg-white relative bottom-0" in:fly={{
    y: -100,
    delay: 100,
    easing: backOut
  }} style="overflow: hidden;">
      <div class="flex justify-between w-full items-center">
        <span class="text-black">Rate Us</span>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span class="p-1 border border-gray-300 rounded-md cursor-pointer" on:click={() => dropdown = null}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.75684 13.2426L13.2421 4.75736" stroke="#173556" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.2421 13.2426L4.75684 4.75735" stroke="#173556" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>        
        </span>
      </div>

      <div class="mt-1">
        <span class="text-xs">
            How do you feel about this our service?
        </span>
        <div>
            {#each rates as rate, i}
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <span 
                    class="mr-2 border-4 border-gray-100 rounded-full bg-gray-100 w-8 h-8 inline-flex justify-center items-center"
                    class:rate={selectedRate !== i}
                    on:click={() => selectRate(i)}
                >{rate}</span>
            {/each}
        </div>
      </div>

      <div class="mt-4">
        <span class="text-xs">
          Write your review
        </span>
        <div class="flex">
            <input
                placeholder="Enter review"
                bind:value={rating.message}
                class="border-0 border-b border-black mr-2 px-2 py-1 text-sm primary-text-color"
            />
            <ButtonRounded
                disabled={false}
                on:click={processRatings}
                size=8
                title=""
                icon="right-arrow"
                iconColor="#30A059"
                iconSize="16"
                loading={loading}
                className="call-btn-bg-color w-10 h-8"
            />
        </div>
        {#if errors.survey}
            <small class="text-xs text-red-600">{ errors.survey }</small>
        {/if}
      </div>

  </div>
</div>
{/if}
<style>
  .primary-bg-color {
      background-color: var(--primary-bg-color)
  }
  .primary-text-color {
    color: var(--primary-text-color)
  }
  .rate {
    filter: grayscale(1);
  }
</style>

